export class Error {
  constructor(props) {
    this.message = props.message;
    this.code = props.code;
  }
}
